import { Events } from "@ctra/components";

/**
 * Map categories to icons
 * @todo deal with this later LOL :)
 */
export const eventCategoryMap = Events.eventCategoryMap;
